"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useIsTablet = require("./useIsTablet");
Object.keys(_useIsTablet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useIsTablet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useIsTablet[key];
    }
  });
});
var _useTranslations = require("./useTranslations");
Object.keys(_useTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useTranslations[key];
    }
  });
});
